import React, { useState } from 'react'
import './css/LoginSignup.css'

const LoginSignup = () => {
  const [state, setState] = useState("Login");
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: ""
  });

  // 🌐 auto-detect backend (localhost for dev, domain for live)
  const API_BASE =
    window.location.hostname === "localhost"
      ? "http://localhost:4000"
      : "https://sonicwaves.in";

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const login = async () => {
    console.log("login executed", formData);

    let responseData;
    try {
      const response = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      responseData = await response.json();

      if (responseData.success) {
        localStorage.setItem("auth-token", responseData.token);
        window.location.replace("/");
      } else {
        alert(responseData.errors || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Unable to connect to server. Please try again later.");
    }
  };

  const signup = async () => {
    console.log("signup executed", formData);

    let responseData;
    try {
      const response = await fetch(`${API_BASE}/signup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      responseData = await response.json();

      if (responseData.success) {
        localStorage.setItem("auth-token", responseData.token);
        window.location.replace("/");
      } else {
        alert(responseData.errors || "Signup failed");
      }
    } catch (error) {
      console.error("Signup error:", error);
      alert("Unable to connect to server. Please try again later.");
    }
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
          {state === "Sign Up" && (
            <input
              value={formData.username}
              name="username"
              type="text"
              onChange={changeHandler}
              placeholder="Username"
            />
          )}
          <input
            name="email"
            onChange={changeHandler}
            value={formData.email}
            type="email"
            placeholder="Email"
          />
          <input
            type="password"
            onChange={changeHandler}
            value={formData.password}
            name="password"
            placeholder="Password"
          />
        </div>

        <button onClick={() => (state === "Login" ? login() : signup())}>
          Continue
        </button>

        {state === "Sign Up" ? (
          <p className="loginsignup-login">
            Already have an account?{" "}
            <span onClick={() => setState("Login")}>Login here</span>
          </p>
        ) : (
          <p className="loginsignup-login">
            Create an account{" "}
            <span onClick={() => setState("Sign Up")}>Click here</span>
          </p>
        )}

        <div className="loginsignup-agree">
          <input type="checkbox" />
          <p>By continuing, I agree to the Terms of Use & Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;
